module.exports = __webpack_public_path__ + "static/media/Search-Icon.ac6b38ca.svg";